<template>
	<div class="accountManagement">
		<div class="nav-tit">
			<div class="nav">
				<span class="click-nav" @click="goToAccountPage">账户管理</span>
				<span v-show="adSeriesShow">
					<span> > </span>
					<el-tooltip
						effect="dark"
						:content="$route.query ? $route.query.adSeriesName : ''"
						placement="top"
					>
						<span class="ellipsis" :class="[adGroupShow ? 'click-nav' : '']" @click="goBackAdSeries"
							>广告系列：{{ $route.query ? $route.query.adSeriesName : '' }}</span
						>
					</el-tooltip>
				</span>
				<span v-show="adGroupShow">
					<span> > </span>
					<el-tooltip
						effect="dark"
						:content="$route.query ? $route.query.adGroupName : ''"
						placement="top"
					>
						<span class="ellipsis">广告组：{{ $route.query ? $route.query.adGroupName : '' }}</span>
					</el-tooltip>
				</span>
			</div>
			<el-date-picker
				v-model="date"
				type="daterange"
				:picker-options="{
					firstDayOfWeek: 1,
				}"
				range-separator="至"
				start-placeholder="开始日期"
				end-placeholder="结束日期"
				value-format="yyyy-MM-dd"
			>
			</el-date-picker>
		</div>
		<sky-tabs v-model="tabValue" :tabList="tabList" :time="date"></sky-tabs>
	</div>
</template>
<script>
import skyTabs from '@/components/iglobalwin/formComponents/tabs/sky-tabs-custom.vue';
import mixinsWatch from '@/client/mixinsWatch/mixinsWatch';
import adSeries from '@/backend/pages/googleAds/adSeries.vue';
import adGroup from '@/backend/pages/googleAds/adGroup.vue';
import advertising from '@/backend/pages/googleAds/advertising.vue';
import keyword from '@/backend/pages/googleAds/keyword.vue';
// import { mapGetters } from 'vuex';
export default {
	data() {
		return {
			tabValue: 'adSeries',
			tabList: [],
			date: [],
		};
	},
	mixins: [mixinsWatch],
	computed: {
		// ...mapGetters(['activeWebsite']),
		adSeriesShow() {
			// 是否显示广告系列导航
			return this.$route.fullPath.indexOf('adSeriesName') != -1;
		},
		adGroupShow() {
			// 是否显示广告组导航
			return this.$route.fullPath.indexOf('adGroupName') != -1;
		},
		// domain() {
		// 	// 监听服务单域名改变
		// 	return this.activeWebsite.domain
		// }
	},
	mounted() {
		if (this.adGroupShow) {
			this.tabValue = 'advertising';
			this.$nextTick(function () {
				this.tabList.splice(0, 2);
			});
		} else if (this.adSeriesShow) {
			this.tabValue = 'adGroup';
			this.$nextTick(function () {
				this.tabList.splice(0, 1);
			});
		} else {
			this.tabValue = 'adSeries';
		}
		this.setTabList();
		let time = [
			this.formatDate(new Date(new Date().getTime() - 3600 * 1000 * 24 * 14)),
			this.formatDate(new Date(new Date().getTime() - 3600 * 1000 * 24 * 1)),
		];
		if (this.$route.path.includes('accountManagement')) {
			// 离开页面时赋值默认值
			this.date = JSON.parse(localStorage.getItem('adTime')) || time;
		}
	},
	watch: {
		$route: {
			handler(val) {
				if (
					val.fullPath.indexOf('adSeriesName') != -1 &&
					val.fullPath.indexOf('adGroupName') != -1 &&
					this.tabList.length == 4
				) {
					if (this.tabValue !== 'advertising') {
						// 从列表点击跳转时，去掉广告系列、广告组这一级
						this.tabList.splice(0, 2);
					}
					if (val.fullPath.indexOf('tabValueKeyword') != -1) {
						// 如果路由包含关键词，则跳转到关键词列表
						this.$nextTick(() => {
							this.tabValue = 'keyword';
						});
					} else {
						// 如果路由不包含关键词，则跳转到广告列表
						this.tabValue = 'advertising';
					}
				} else if (val.fullPath.indexOf('adSeriesName') != -1) {
					this.goToAdSeries();
					if (
						val.fullPath.indexOf('adSeriesName') != -1 &&
						val.fullPath.indexOf('adGroupName') != -1
					) {
						this.goToAdGroup();
					}
				}
			},
			deep: true,
			immediate: true,
		},
		date: {
			handler(val) {
				localStorage.setItem('adTime', JSON.stringify(this.date)); // 广告日期存储
			},
			// immediate: true,
			deep: true,
		},
		// domain: {
		// 	handler (val) {
		// 		let time = [this.formatDate(new Date(new Date().getTime() - 3600 * 1000 * 24 * 14)), this.formatDate(new Date(new Date().getTime() - 3600 * 1000 * 24 * 1))];
		// 		localStorage.setItem('adTime',JSON.stringify(time)); // 广告日期
		// 		this.date = time;
		//   },
		// immediate: true,
		// deep: true,
		// }
	},
	methods: {
		//格式化时间
		formatDate(date) {
			var myyear = date.getFullYear();
			var mymonth = date.getMonth() + 1;
			var myweekday = date.getDate();

			if (mymonth < 10) {
				mymonth = '0' + mymonth;
			}
			if (myweekday < 10) {
				myweekday = '0' + myweekday;
			}
			return myyear + '-' + mymonth + '-' + myweekday;
		},
		requestData() {
			this.tabList = [];
			this.setTabList();
			// this.$nextTick(function () {
			// });
		},
		setTabList() {
			let self = this;
			this.tabList = [
				{
					label: '广告系列',
					name: 'adSeries',
					type: adSeries,
					isShow: !self.adSeriesShow,
				},
				{
					label: '广告组',
					name: 'adGroup',
					type: adGroup,
				},
				{
					label: '广告',
					name: 'advertising',
					type: advertising,
				},
				{
					label: '关键词',
					name: 'keyword',
					type: keyword,
				},
			];
		},
		// 跳转回账户页
		goToAccountPage() {
			if (this.tabValue !== 'adSeries' && this.adGroupShow) {
				// 三级导航时，广告组存在
				this.tabList.unshift({
					label: '广告组',
					name: 'adGroup',
					type: adGroup,
				});
			}
			if (this.tabValue !== 'adSeries' && this.adSeriesShow) {
				// 二级导航时，广告系列存在
				this.tabList.unshift({
					label: '广告系列',
					name: 'adSeries',
					type: adSeries,
				});
			}

			this.tabValue = 'adSeries';
			this.$router.push({
				name: 'accountManagement',
			});
		},
		// 点击导航面包屑回广告系列层级
		goBackAdSeries() {
			if (this.tabValue !== 'adSeries' && this.adGroupShow) {
				// 三级导航时，广告组存在
				this.tabList.unshift({
					label: '广告组',
					name: 'adGroup',
					type: adGroup,
				});
			}
			this.tabValue = 'adGroup';
			this.$router.push({
				name: 'accountManagement',
				query: {
					adSeriesId: this.$route.query.adSeriesId,
					adSeriesName: this.$route.query.adSeriesName,
				},
			});
		},
		// 点击广告系列跳转
		goToAdSeries() {
			if (this.tabValue !== 'adGroup') {
				// 从列表点击跳转时，去掉广告系列这一级
				this.tabList.splice(0, 1);
			}

			this.tabValue = 'adGroup';
		},
		// 点击广告组跳转
		goToAdGroup() {
			if (this.tabValue !== 'advertising') {
				// 从列表点击跳转时，去掉广告组这一级
				this.tabList.splice(0, 1);
			}

			this.tabValue = 'advertising';
		},
	},
	destroyed() {
		if (!this.$route.path.includes('accountManagement')) {
			localStorage.setItem('adSeriesStatus', JSON.stringify(['ENABLED', 'PAUSED'])); // 广告系列默认搜索条件
			localStorage.setItem(
				'adGroupStatus',
				JSON.stringify({ status: ['ENABLED', 'PAUSED'], adGroupStatus: ['ENABLED', 'PAUSED'] })
			); // 广告组默认搜索条件
			localStorage.setItem(
				'adStatus',
				JSON.stringify({
					status: ['ENABLED', 'PAUSED'],
					adGroupStatus: ['ENABLED', 'PAUSED'],
					adStatus: ['ENABLED', 'PAUSED'],
				})
			); // 广告默认搜索条件
			localStorage.setItem(
				'adKeywordStatus',
				JSON.stringify({
					status: ['ENABLED', 'PAUSED'],
					adGroupStatus: ['ENABLED', 'PAUSED'],
					keyWordStatus: ['ENABLED', 'PAUSED'],
				})
			); // 关键词默认搜索条件
			localStorage.removeItem('adTime'); // 广告日期清除
		}
	},
	components: { skyTabs, adSeries, adGroup, advertising, keyword },
};
</script>
<style lang="scss" scoped>
.accountManagement {
	width: 100%;
	// padding: 0 20px;
	.nav-tit {
		display: flex;
		justify-content: space-between;
		background-color: #fff;
		border-bottom: 1px solid #e8e8e8;
		border-radius: 4px 4px 0 0;
		height: 54px;
		align-items: center;
		padding: 0 15px;
		.nav {
			font-size: 16px;
			.click-nav {
				cursor: pointer;
			}
			.click-nav:hover {
				color: #1890ff;
			}
			.ellipsis {
				max-width: 400px;
				display: inline-block;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				vertical-align: bottom;
			}
		}
	}
	.sky-tabs {
		width: 100%;
		padding: 10px 15px 0;
		border-bottom: 1px solid #e8e8e8;
		background-color: #fff;
	}

	.accountManagement-datalist {
		width: 100%;
		background-color: #fff;
	}
}
</style>
